import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "Antalya'ya gitmek için en iyi zaman hangisi?",
    a: "Antalya'yı ziyaret etmek için en ideal dönemler Nisan–Haziran ve Eylül–Kasım aylarıdır. Bu dönemlerde deniz suyu yüzme için uygun sıcaklıkta, hava ılıman ve kalabalık görece azdır. Temmuz–Ağustos en sıcak ve en kalabalık dönemdir; ancak deniz tatili için tercih edilebilir. Kış aylarında Antalya ılıman kalır ve tarihi mekanlar daha sakin ziyaret edilebilir.",
  },
  {
    q: "Antalya'da mutlaka görülmesi gereken yerler hangileri?",
    a: "Kaleiçi (tarihi şehir merkezi), Hadrian Kapısı, Yivli Minare, Antalya Müzesi, Düden Şelalesi, Konyaaltı ve Lara plajları, Perge Antik Kenti, Aspendos Tiyatrosu, Termessos ve Side antik kenti Antalya'nın mutlaka görülmesi gereken yerleri arasındadır.",
  },
  {
    q: "Antalya'da hangi plajlar en güzel?",
    a: "Antalya'nın en güzel plajları arasında Kaputaş Plajı (Kaş-Kalkan arası, turkuaz rengi), Patara Plajı (18 km uzunluğuyla Türkiye'nin en uzun plajı), Ölüdeniz Mavi Lagün (Fethiye), Kleopatra Plajı (Alanya), Konyaaltı Plajı (şehir merkezi) ve Phaselis Plajı (antik kent içinde) sayılabilir.",
  },
  {
    q: "Antalya'ya nasıl gidilir?",
    a: "Antalya Havalimanı, Türkiye'nin en yoğun havalimanlarından biridir ve İstanbul, Ankara başta olmak üzere pek çok şehirden direkt uçuş mevcuttur. Avrupa'dan da çok sayıda charter uçuşu düzenlenmektedir. İstanbul'dan otobüsle yaklaşık 10–12 saat sürer. Şehir içinde ulaşım için tramvay, dolmuş ve taksi kullanılabilir.",
  },
  {
    q: "Antalya'da kaç gün geçirmek gerekir?",
    a: "Antalya şehir merkezini (Kaleiçi, müze, plajlar) görmek için 2–3 gün yeterlidir. Çevredeki antik kentleri (Perge, Aspendos, Side, Termessos) ve doğal güzellikleri (Düden Şelalesi, Köprülü Kanyon) eklerseniz 5–7 gün idealdir. Antalya'yı üs olarak kullanarak Kaş, Kalkan, Ölüdeniz ve Pamukkale'ye günübirlik turlar da yapılabilir.",
  },
  {
    q: "Antalya'da rafting ve doğa aktiviteleri yapılabilir mi?",
    a: "Evet, Antalya doğa aktiviteleri açısından Türkiye'nin en zengin destinasyonlarından biridir. Köprülü Kanyon'da rafting, Toros Dağları'nda trekking, Beydağları Sahil Milli Parkı'nda yürüyüş, Alanya'da dalış ve su sporları, Saklıkent Gorge'da kanyoning ve Termessos'ta antik kent yürüyüşü en popüler aktiviteler arasındadır.",
  },
  {
    q: "Antalya'da nerede konaklayabilirim?",
    a: "Kaleiçi, tarihi atmosferi ve merkezi konumuyla butik otel arayanlar için idealdir. Konyaaltı ve Lara plaj bölgeleri büyük resort otellerin yoğunlaştığı alanlardır. Belek, golf ve lüks tatil köyleriyle tanınır. Kaş ve Kalkan ise daha sakin ve butik bir tatil arayanlar için mükemmeldir. Bütçenize ve tatil anlayışınıza göre geniş bir seçenek yelpazesi mevcuttur.",
  },
  {
    q: "Antalya'dan günübirlik gezi yapılabilecek yerler var mı?",
    a: "Antalya'dan günübirlik yapılabilecek en popüler destinasyonlar: Pamukkale ve Hierapolis (3 saat), Side antik kenti (1 saat), Aspendos Tiyatrosu (45 dakika), Perge Antik Kenti (30 dakika), Köprülü Kanyon (1,5 saat), Kaş ve Kalkan (2 saat) ile Ölüdeniz (2,5 saat)'dir.",
  },
  {
    q: "Antalya'da ne yenilmeli?",
    a: "Antalya'da mutlaka tatmanız gereken lezzetler: piyaz (beyaz fasulye salatası, Antalya'ya özgü), şiş köfte, taze deniz ürünleri, Alanya'da taze muz ve avokado, Kaş'ta Akdeniz mezeleri ve zeytinyağlı yemekler. Kaleiçi'ndeki restoranlar ve Konyaaltı sahilindeki balık lokantaları en popüler yeme-içme noktalarıdır.",
  },
  {
    q: "Antalya'da Aspendos Tiyatrosu nasıl ziyaret edilir?",
    a: "Aspendos Tiyatrosu, Antalya'ya 47 km uzaklıkta Serik ilçesindedir. Şehir merkezinden araçla yaklaşık 45 dakika sürer. Tur araçları ve özel araç kiralama ile ulaşılabilir. Tiyatro, dünyanın en iyi korunmuş Roma tiyatrolarından biridir ve her yıl Aspendos Opera ve Bale Festivali'ne ev sahipliği yapar. Ziyaret saatleri 08:00–19:00 arasındadır.",
  },
  {
    q: "Antalya'da alışveriş için en iyi yerler nereler?",
    a: "Kaleiçi'ndeki el sanatları dükkanları (deri ürünler, takılar, halılar), Antalya Migros AVM ve TerraCity AVM (modern alışveriş), Kalekapısı çevresindeki butik mağazalar ve Pazar yerleri (yerel ürünler, baharatlar, zeytinyağı) Antalya'nın en popüler alışveriş noktalarıdır.",
  },
  {
    q: "Antalya'da güvenlik nasıl?",
    a: "Antalya, Türkiye'nin en güvenli turistik şehirlerinden biridir. Turistik bölgelerde yankesicilere karşı dikkatli olunması önerilir. Plajlarda değerli eşyalarınızı gözetimsiz bırakmayın. Lisanslı taksi veya uygulamalar üzerinden araç çağırmanızı öneririz. Genel olarak şehir, yabancı turistler için oldukça güvenli ve misafirperver bir atmosfer sunmaktadır.",
  },
];

const AntalyaFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "Antalya Seyahat SSS — Plajlar, Antik Kentler ve Tatil Rehberi 2026";
    const desc = "Antalya'ya seyahat planlayanlar için en sık sorulan sorular: en güzel plajlar, antik kentler, ulaşım, konaklama ve aktiviteler hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/antalya-sss");
    setMeta("description", desc);
    setMeta("keywords", "antalya seyahat, antalya plajlar, antalya antik kentler, antalya sss, antalya rehberi, antalya tatil, antalya gezilecek yerler, antalya kaleici, antalya duden selalesi, antalya muzesi, antalya kemer, antalya alanya, antalya side, antalya aspendos, antalya perge, antalya termessos, antalya manavgat, antalya belek, antalya kas, antalya kalkan, antalya olympos, antalya phaselis, antalya koprulu kanyon, antalya rafting, antalya kaputas plaji, antalya patara plaji, antalya lara plaji, antalya konyaalti plaji, antalya ne zaman gidilir, antalya konaklama, antalya ulasim, antalya gunubirlik gezi, antalya alisveris, antalya guvenlik, akdeniz tatil yerleri, turkiye en iyi plajlar");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/antalya-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Antalya%20Kaleici%20Old%20town%20harbor%20marina%20Mediterranean%20sea%20Kaputas%20beach%20Turkey%20aerial&width=1200&height=630&seq=ant-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-antalya-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-antalya-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "Antalya SSS", "item": "https://geziturkiyem.com/antalya-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      const s1 = document.getElementById("schema-antalya-faq");
      const s2 = document.getElementById("schema-antalya-breadcrumb");
      if (s1) s1.remove();
      if (s2) s2.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Antalya%20Kaleici%20Old%20town%20harbor%20marina%20Mediterranean%20sea%20turquoise%20water%20Turkey%20aerial%20panoramic%20golden%20sunset&width=1400&height=500&seq=ant-sss-hero&orientation=landscape"
            alt="Antalya"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Antalya SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Antalya Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            Antalya'ya seyahat planlayanların en çok merak ettiği sorular ve kapsamlı cevapları.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        {/* Intro */}
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-sun-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                Antalya Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Türkiye'nin turizm başkenti olarak anılan Antalya; turkuaz Akdeniz suları, antik kentleri, Toros Dağları manzarası ve tarihi Kaleiçi ile her yıl 15 milyonu aşkın ziyaretçiyi ağırlamaktadır. Aşağıda Antalya seyahati hakkında en sık sorulan soruları ve cevaplarını bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Related Links */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/istanbul-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-building-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">İstanbul SSS</p>
            <p className="text-xs text-stone-400">Boğaz ve tarihi yarımada rehberi</p>
          </Link>
          <Link to="/kapadokya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-landscape-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Kapadokya SSS</p>
            <p className="text-xs text-stone-400">Peri bacaları ve balon turları</p>
          </Link>
          <Link to="/place/antalya-kaleiçi" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-map-pin-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Antalya Kaleiçi</p>
            <p className="text-xs text-stone-400">Tarihi şehir merkezi rehberi</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AntalyaFaq;
